import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  TextField,
  MenuItem,
  Button,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Label from "../../../components/Label/Label";
import Buttons from "../../../components/Controls/Buttons/Button";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
 
const DateInput = ({ label, value, onChange, minDate, maxDate }) => {
  return (
    <DatePicker
      selected={value ? new Date(value) : null}
      showYearDropdown
      scrollableYearDropdown
      yearDropdownItemNumber={150}
      // popperClassName="custom-datepicker-popper"
      onChange={(date) => {
        onChange(date);
      }}
      dateFormat="dd-MMM-yyyy"
      minDate={minDate}
      maxDate={maxDate}
      customInput={
        <TextField
          label={label}
          size="small"
          fullWidth
          InputLabelProps={{ shrink: true }}
        />
      }
    />
  );
};

const BatchFilterPopup = ({
  open,
  onClose,
  filterValues,
  onChange,
  onReset,
  onGenerate,
  isStatusVisible,
  data,
  filterOptions,
  userList,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      sx={{ borderRadius: "16px !important", margin: 0 }}
      BackdropProps={{
        style: { backgroundColor: "transparent" },
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          maxWidth: "276px",
          boxShadow: "none",
          bottom: 0,
          position: "fixed",
          left: 58,
          margin: 0,
          boxShadow: "none",
          maxHeight: "calc(100vh - 150px)",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{ backgroundColor: "#E8EDF4", minHeight: "calc(100vh - 143px)" }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: 14,
            fontWeight: 600,
            paddingLeft: "10px",
            alignItems: "center",
            overflow: "hidden",
            height: "48px",
          }}
        >
          Filter
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
            height: "100%",
            padding: "5px",
            overflow: "auto",
            height: "calc(100vh - 200px)",
          }}
        >
          <DialogContent
            sx={{
              padding: "0px",
              boxShadow: "none",
              // minHeight: "calc(100vh - 280px)",
              overflow: "auto",
            }}
          >
            {(filterValues?.batch_status === "" || filterValues?.batch_status) && <Box
              display="flex"
              flexDirection="column"
              gap={2}
              p={1}
              mb={1}
              sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
            >
              <Label text={"Status"}> </Label>
              <TextField
                select
                label="Status"
                size="small"
                fullWidth
                value={filterValues?.batch_status}
                onChange={(e) => onChange("batch_status", e.target.value)}
              >
                <MenuItem value="">Select</MenuItem>
                {filterOptions?.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
                {/* <MenuItem value="Invalid">Invalid</MenuItem> */}
              </TextField>
            </Box>}
            {(filterValues?.uploaded_by === "" ||
              filterValues?.uploaded_by) && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={2}
                  p={1}
                  mb={1}
                  sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
                >
                  <Label text={"Uploaded By"}> </Label>
                  <TextField
                    select
                    label="Uploaded By"
                    size="small"
                    fullWidth
                    value={filterValues?.uploaded_by}
                    onChange={(e) => onChange("uploaded_by", e.target.value)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {userList?.data?.map((option) => (
                      <MenuItem key={option.username} value={option.username}>
                        {option.username}
                      </MenuItem>
                    ))}
                    {/* <MenuItem value="Invalid">Invalid</MenuItem> */}
                  </TextField>
                </Box>
              )}
            {(filterValues?.approved_by === "" ||
              filterValues?.approved_by) && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={2}
                  p={1}
                  mb={1}
                  sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
                >
                  <Label text={"Approved By	"}> </Label>
                  <TextField
                    select
                    label="Approved By	"
                    size="small"
                    fullWidth
                    value={filterValues?.approved_by}
                    onChange={(e) => onChange("approved_by", e.target.value)}
                  >
                    <MenuItem value="">Select</MenuItem>
                    {userList?.data.map((option) => (
                      <MenuItem key={option.username} value={option.username}>
                        {option.username}
                      </MenuItem>
                    ))}
                    {/* <MenuItem value="Invalid">Invalid</MenuItem> */}
                  </TextField>
                </Box>
              )}
            {(filterValues?.from_date === "" || filterValues?.from_date) && (
              <Box
                display="flex"
                flexDirection="column"
                gap={2}
                p={1}
                mb={1}
                sx={{
                  backgroundColor: "#ffff",
                  borderRadius: "8px",
                  boxShadow: "none",
                }}
              >
                <Label text={"Date of Manufacture"}> </Label>
                <DateInput
                  label="From"
                  value={filterValues?.from_date}
                  onChange={(val) => onChange("from_date", val)}
                  maxDate={filterValues.to_date}
                />

                <DateInput
                  label="To"
                  value={filterValues?.to_date}
                  onChange={(val) => onChange("to_date", val)}
                  minDate={filterValues.from_date}
                />
              </Box>
            )}
            {(filterValues?.approve_start_date === "" ||
              filterValues?.approve_start_date) && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={2}
                  p={1}
                  mb={1}
                  sx={{
                    backgroundColor: "#ffff",
                    borderRadius: "8px",
                    boxShadow: "none",
                  }}
                >
                  <Label text={"Approved Date"}> </Label>
                  <DateInput
                    label="From"
                    value={filterValues?.approve_start_date}
                    onChange={(val) => onChange("approve_start_date", val)}
                    maxDate={filterValues.approve_end_date}
                  />

                  <DateInput
                    label="To"
                    value={filterValues?.approve_end_date}
                    onChange={(val) => onChange("approve_end_date", val)}
                    minDate={filterValues.approve_start_date}
                  />
                </Box>
              )}
            {(filterValues?.created_start_date === "" ||
              filterValues?.created_start_date) && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={2}
                  p={1}
                  mb={1}
                  sx={{
                    backgroundColor: "#ffff",
                    borderRadius: "8px",
                    boxShadow: "none",
                  }}
                >
                  <Label text={"Uploaded Date"}> </Label>
                  <DateInput
                    label="From"
                    value={filterValues?.created_start_date}
                    onChange={(val) => onChange("created_start_date", val)}
                    maxDate={filterValues.created_end_date}
                  />

                  <DateInput
                    label="To"
                    value={filterValues?.created_end_date}
                    onChange={(val) => onChange("created_end_date", val)}
                    minDate={filterValues.created_start_date}
                  />
                </Box>
              )}
            {(filterValues?.updated_created_date === "" ||
              filterValues?.updated_created_date) && (
                <Box
                  display="flex"
                  flexDirection="column"
                  gap={2}
                  p={1}
                  mb={1}
                  sx={{
                    backgroundColor: "#ffff",
                    borderRadius: "8px",
                    boxShadow: "none",
                  }}
                >
                  <Label text={"Updated Date"}> </Label>
                  <DateInput
                    label="From"
                    value={filterValues?.updated_created_date}
                    onChange={(val) => onChange("updated_created_date", val)}
                    maxDate={filterValues.updated_end_date}
                  />

                  <DateInput
                    label="To"
                    value={filterValues?.updated_end_date}
                    onChange={(val) => onChange("updated_end_date", val)}
                    minDate={filterValues.updated_created_date}
                  />
                </Box>
              )}
            {/* <Box
            display="flex"
            flexDirection="column"
            gap={2}
            p={2}
            mb={2}
            sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
          >
            <Label text={"Unit Operations"}> </Label>
            <TextField
              select
              label="Batch Values Status"
              size="small"
              fullWidth
              value={filterValues.batchValuesStatus || "All"}
              onChange={(e) => onChange("batchValuesStatus", e.target.value)}
            >
              <MenuItem value="All">All</MenuItem>
              <MenuItem value="Valid">Valid</MenuItem>
              <MenuItem value="Invalid">Invalid</MenuItem>
            </TextField>
          </Box> */}
          </DialogContent>
          <Box
            display="flex"
            justifyContent="end"
            gap={1}
            p={1}
            sx={{ backgroundColor: "#ffff", borderRadius: "8px" }}
          >
            <Button variant="outlined" onClick={onReset}>
              Reset
            </Button>
            <Buttons
              text="Submit"
              variant="contained"
              onClick={onGenerate}
              loading={data?.loader}
            ></Buttons>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default BatchFilterPopup;
